// extracted by mini-css-extract-plugin
module.exports = {"hero-image":"_2nkLC","headline-block":"_1iBdJ","summary":"_1gx2Q","share-block":"_1sYHP","card":"_3BcBF","sticky-title":"_1YQRh","content":"_7qBRP"};